import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState'
import Loading from '../../../../util/Loading'
import { ToastContainer, toast } from 'react-toastify';
import { createNewCategory, updateCategory } from '../../../../action'

export default function CategoryForm() {
    const { categoryId } = useParams();
    TabTitle(categoryId > 0 ? "Update Category" : "Create Category");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [categoryDetail] = state.categoryAPI.categoryDetail;
    const [id, setId] = state.categoryAPI.id;
    const [callback, setCallback] = state.categoryAPI.callback;

    const [btnName, setBtnName] = useState("Save");
    const [focused, setFocused] = useState(false);
    const [values, setValues] = useState([]);
    //Focus input elements
    const handleFocus = (e) => {
        setFocused(true)
    }

    //Get value form input elements and assign into values states
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        if (categoryId > 0) {
            setBtnName("Update")
            setId(categoryId)

            setValues({
                name: categoryDetail.name ? categoryDetail.name : "",
                description: categoryDetail.description ? categoryDetail.description : "",
            })
        }
    }, [id, categoryId, categoryDetail])


    const submitForm = (e) => {
        e.preventDefault();
        const categoryInfo = {
            "name": values.name,
            "description": values.description,
            'updatedBy': signInUser.id
        }

        if (categoryId > 0) {
            updateCategory(categoryId, categoryInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        } else {
            categoryInfo.createdBy = signInUser.id
            createNewCategory(categoryInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        }
    }

    return (
        !categoryDetail ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
            : <div className="form-container">
                <header>Category Form</header>
                <form onSubmit={submitForm} className="form">
                    <div className="input-box">
                        <label htmlFor="name">Category Name</label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            placeholder='Enter Category Name'
                            value={values.name || ""}
                            required pattern='^[A-Za-z ,]{3,}$'
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeValue}
                        />
                        <span>Name should be above 3 characters and shouldn't any spacial character</span>
                    </div>

                    <div className="input-box">
                        <label htmlFor="description">Description</label>
                        <textarea
                            name="description"
                            id="description"
                            cols="30" rows="5"
                            placeholder='Enter Category Description'
                            value={values.description || ""}
                            onChange={onChangeValue}
                        />
                    </div>

                    <div className="form-button">
                        <button className="add_new">{btnName}</button>
                    </div>
                </form>
                <ToastContainer />
            </div>
    )
}
